<app-page-header
  title="Home"
  titleLink="/dashboard/"
  active_item="Dashboards"
></app-page-header>

<div class="row">
  <h5>{{ 'common.updatedValues' | translate }}</h5>
</div>

<div class="row row-sm">
  <div class="col-xl-3 col-md-6">
    <app-available-balance-card />
  </div>
  <div class="col-xl-3 col-md-6">
    <app-general-balance-card />
  </div>
  <div class="col-xl-3 col-md-6">
    <app-todays-sales-card />
  </div>
  <div class="col-xl-3 col-md-6">
    <app-average-daily-ticket-card />
  </div>
</div>

<div class="row middle-header">
  <h5>{{ 'common.last7days' | translate }}</h5>
</div>

<div class="row row-sm">
  <div class="col-xl-6 col-md-6">
    <div class="row row-sm">
      <div class="col-xl-6 col-md-6">
        <app-sales-received-quantity-card />
      </div>
      <div class="col-xl-6 col-md-6">
        <app-received-sales-card />
      </div>
    </div>

    <div class="row row-sm">
      <div class="col-xl-6 col-md-6">
        <app-average-sales-ticket-card />
      </div>
      <div class="col-xl-6 col-md-6">
        <app-receipt-conversion-card />
      </div>
    </div>
  </div>

  <div class="col-xl-6 col-md-6">
    <app-weekly-sales-graph />
  </div>
</div>

<div class="row middle-header">
  <h5>{{ 'common.monthlyAnalysis' | translate }}</h5>
</div>

<div class="row last-card">
  <div class="col-xl-12 col-md-12">
    <app-statistics-sales-graph />
  </div>
</div>